import axios from "axios";

let interval = null;

export default {
  namespaced: true,

  state: {
    loginError: false,
    authenticationToken: null
  },

  mutations: {
    loginError(state, val) {
      state.loginError = val;
    },

    authenticationToken(state, val) {
      state.authenticationToken = val;
    }
  },

  actions: {
    /*
    auth({ commit, dispatch }, authenticationToken) {
      commit("authenticationToken", authenticationToken);

      axios({
          method: "get",
          url: "/wp-json/sw-immoapp/v1/auth/me",
          headers: {
          Authorization: `Bearer ${authenticationToken}`
          }
      }).then((res) => {
          commit("authUser", res.data, { root: true });
          dispatch("appLoaded", true, { root: true });
      }).catch(() => {
          dispatch("appLoaded", true, { root: true });
      });
    },
    */

    email({ commit }, email) {
      commit("loading", true, { root: true });

      return axios({
        method: "post",
        url: "/wp-json/sw-immosuite/v1/auth/email",
        data: {
          email: email
        }
      }).then((res) => {
        return res.data;
      }).finally(() => {
        commit("loading", false, { root: true });
      });
    },

    login({ commit }, k) {
      commit("loading", true, { root: true });

      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: "/wp-json/sw-immosuite/v1/auth/login",
          data: {
            k: k
          }
        }).then((res) => {
          const data = res.data;
          commit("authUser", data.user, { root: true });

          if (data.login) {
            // fresh login
            axios({
              method: "post",
              url: "/wp-json/sw-immosuite/v1/auth/login/nonce",
              data: {
                k: k
              }
            }).then(res => {
              commit("authenticationToken", res.data.nonce);
              resolve();
            });
          } else {
            resolve();
          }
        }).catch((err) => {
          reject(err);
        }).finally(() => {
          commit("loading", false, { root: true });
        });
      });
    },

    logout({ commit, dispatch }) {
      dispatch("ajax", {
          method: "delete",
          url: "/v1/auth/me"
      }, { root: true }).then(() => {
          dispatch("userMessage", {
            type: "error",
            msg: "Sie wurden abgemeldet."
          }, { root: true });

          commit("authUser", null, { root: true });
      });
    },

    me({ commit, dispatch, state, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: "/wp-json/sw-immosuite/v1/auth/me",
          headers: {
            "X-WP-Nonce": "" + state.authenticationToken
          }
        }).then((res) => {
          // ok
          if (!rootState.user.loggedIn) {
            commit("authUser", res.data, { root: true });
          }

          resolve(rootState.user.loggedIn);
        }).catch((err) => {
          const s = err.toString();

          if (s.indexOf("403") !== -1) {
            commit("authUser", null, { root: true });
          } else {
            dispatch("userMessage", {
              type: "error",
              msg: "Fehler bei der Netzwerkverbindung"
            }, { root: true });
          }

          reject(err);
        });
      });
    },

    start({ dispatch }) {
      if (interval) {
        return;
      }

      interval = window.setInterval(() => {
        dispatch("me");
      }, 60000);
    },

    destroy() {
      if (interval) {
        clearInterval(interval);
      }
    }
  }
};
